export default "__VITE_ASSET__CssVfJdl__"